import React, { Component } from "react";
import "../style/story.scss";
import * as GetStoryListAPI from "../apis/GetStoryListAPI";
import Pagination from "@material-ui/lab/Pagination";
import EditStory from "../icon/EditStory";
import DeleteIcon from "../icon/DeleteIcon";
import AddStory from "../icon/AddStory";
import Comment from "../icon/CommentIcon";
import * as DeleteTieZiAPI from "../apis/DeleteTieZiAPI";
import Loading from "./common/Loading";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import NoContent from "../icon/NoContent";
import { FlagIcon } from "react-flag-kit";
import Select from "react-select";
import { getCategoryListN } from "../apis/GetCategoryListAPI";

class Story extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 6,
      count: 1,
      storyList: [],
      loadingShow: false,
      categoryList: [],
      category: null,
    };
    this.getStoryList = this.getStoryList.bind(this);
    this.routeComment = this.routeComment.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.routeAddStory = this.routeAddStory.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.delete = this.delete.bind(this);
    this.changeCategory = this.changeCategory.bind(this);
  }

  componentDidMount() {
    const { page, per_page } = this.state;
    this.getStoryList(page, per_page);
    this.getCategoryList();
  }

  getStoryList(page, per_page, category) {
    this.toggleShow();
    GetStoryListAPI.getStoryList(page, per_page, category).then((res) => {
      var status = res.status;
      this.toggleShow();
      if (status === 200) {
        var data = res.data.data;
        var total = data.total;
        let count = Math.ceil(total / per_page);
        this.setState({ count, storyList: data.list });
      }
    });
  }

  getCategoryList() {
    getCategoryListN().then((res) => {
      const data = res.data.data;
      if (data && data.list) {
        const list = data.list.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        this.setState({
          categoryList: list,
        });
      }
    });
  }

  handlePageChange(e, page) {
    this.setState({ page: page }, () => {
      this.getStoryList(page, this.state.per_page, this.state.category);
    });
  }

  routeComment(id) {
    const { history } = this.props;
    history.push(`/Comment?id=${id}`);
  }

  routeAddStory(id) {
    let { history } = this.props;
    if (id !== "") {
      history.push(`/AddStory/${id}`);
      return;
    }
    history.push(`/AddStory`);
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  delete(id) {
    this.toggleShow();
    DeleteTieZiAPI.deleteTieZi(id).then((res) => {
      this.toggleShow();
      var code = res.data.code;
      if (code === 1) {
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "删除成功",
          }),
        );
        this.getStoryList(this.state.page, this.state.per_page);
      } else {
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "操作失败",
          }),
        );
      }
    });
  }

  changeCategory(e) {
    this.setState({ category: e.label }, () => {
      this.getStoryList(this.state.page, this.state.per_page, e.label);
    });
  }

  render() {
    const { page, count, storyList, categoryList, category } = this.state;
    return (
      <React.Fragment>
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        <div className="story-page">
          <div className="toolbar">
            <div className="select-box">
              <Select
                options={categoryList}
                onChange={(e) => this.changeCategory(e)}
                value={categoryList.find((item) => item.label === category)}
              />
            </div>
            <AddStory
              size={30}
              color="#696cff"
              className="icon"
              onClick={() => this.routeAddStory("")}
            />
          </div>
          <div className="content">
            <div className="li-header">
              <div className="left">
                <div className="country">COUNTRY</div>
                <div className="category">CATEGORY</div>
                <div className="logo">LOGO</div>
                <div className="name">NAME</div>
                <div className="description">DESCRIPTION</div>
                <div className="time">TIME</div>
              </div>
              <div className="tool">OPERATION</div>
            </div>
            {storyList.length > 0 ? (
              <React.Fragment>
                {storyList.map((item, index) => {
                  return (
                    <div className="li" key={index}>
                      <div className="left">
                        <div className="country">
                          <FlagIcon
                            code={item.country_code}
                            style={{
                              width: "18px",
                              height: "10px",
                              marginRight: "10px",
                            }}
                            className="flag"
                          />
                          {item.country_code}
                        </div>
                        <div className="category">{item.category_name}</div>
                        <div className="logo">
                          <div className="img">
                            <img src={BASE_URL + item.logo} alt="" />
                          </div>
                        </div>

                        <div className="name">{item.nickname}</div>
                        <div className="description">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          ></p>
                        </div>
                        <div className="time">{item.updatetime}</div>
                      </div>
                      <div className="tool">
                        <EditStory
                          size={20}
                          color="#696cff"
                          className="icon"
                          onClick={() => this.routeAddStory(item.id)}
                        />
                        <Comment
                          size={20}
                          color="#696cff"
                          className="icon"
                          onClick={() => this.routeComment(item.id)}
                        />
                        <DeleteIcon
                          size={20}
                          color="#696cff"
                          className="icon"
                          onClick={() => this.delete(item.id)}
                        />
                      </div>
                    </div>
                  );
                })}
              </React.Fragment>
            ) : (
              <div className="no-content">
                {" "}
                <NoContent size={150} color="#707070" />
              </div>
            )}
          </div>
          <div className="footer">
            <Pagination
              count={count}
              page={page}
              onChange={this.handlePageChange}
              variant="outlined"
              color="standard"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Story;
